export const openIdProps = {
    configuration: {
        client_id: 'sohaib+user1@visnext.com',
        loadUserInfo: true,
        authority: 'https://keycloak-riadev.staging.adelphis.co:8443/realms/demo',
        service_worker_relative_url: '/OidcServiceWorker.js',
        service_worker_only: true,
        token_renew_mode: 'access_token_invalid',
        refresh_time_before_tokens_expiration_in_second: 10,
        scope: 'openid profile email offline_access',
        redirect_uri: window.location.origin + '/authentication/callback',
        silent_redirect_uri: window.location.origin + '/authentication/silent-callback',
    },
};
